import React from 'react'
import ReactDOM from 'react-dom/client'
import { Providers } from './components/providers'
import './styles/index.css';
import App from './App';
import { initMobileBridge } from './lib/mobile-bridge';

// Initialize mobile bridge before React renders.
// This parses WebView URL params (accessToken, refreshToken, etc.)
// and saves them to stores/localStorage so auth is ready on first render.
initMobileBridge();

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <Providers>
            <App />
        </Providers>
    </React.StrictMode>,
)
